import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import Helpers from "../../resources/js/utils/helpers";

export default class Video extends Helpers {
  constructor() {
    super();
    Fancybox.bind("[data-fancybox]", {});
    Helpers.registerHandler(
      "click",
      this.ajaxLoadMore.bind(this),
      ".video-load-more",
    );
  }

  async ajaxLoadMore(el) {
    if (el.classList.contains("is-loading")) return;

    const playListId = el.getAttribute("data-playlist");
    const currentOffset = parseInt(el.getAttribute("data-offset"));
    const sortBy = el.getAttribute("data-sort");

    const section = el.closest(".videos-row");
    const container = section.querySelector(".video-load-more-container");

    el.classList.add("is-loading");
    el.innerText = "Cargando...";

    try {
      const result = await this.ajaxFetchPost({
        action: "ajax_load_video",
        playlist_id: playListId,
        offset: currentOffset,
        sort_by: sortBy,
      });

      if (result.success) {
        container.insertAdjacentHTML("beforeend", result.data.html);

        el.setAttribute("data-offset", result.data.new_offset);

        if (!result.data.has_more) {
          el.remove();
        }

        if (typeof Fancybox !== "undefined") {
          Fancybox.bind("[data-fancybox]", {});
        }
      } else {
        container.insertAdjacentHTML(
          "afterend",
          `<div class="sk-error-message"><p>No se pudieron cargar las publicaciones. Por favor, intenta de nuevo.</p></div>`,
        );

        console.error(result.data?.message || "Something went wrong.");
      }
    } catch (error) {
      console.error("AJAX Error:", error);
    } finally {
      el.classList.remove("is-loading");
      el.innerText = "Ver todos los vídeos";
    }
  }
}

new Video();
